import { Table, Input, Space, Typography, Button, Flex } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FileAddOutlined, FileTextOutlined, PlusOutlined } from '@ant-design/icons';
import { filterBySearch } from '../../utils/search';
import { highlightMatch } from '../../utils/highlight';
import { getTagColor } from '../../utils/certificates';
import ExcelUploadModal from '../../components/ExcelUpload';
import certificateStore from '../../store/CertificateStore';
import { observer } from 'mobx-react-lite';
import Loader from '../../components/Loader';
import CertificateModalForm from '../../components/Certificates/CertificateModalForm';
import employeeStore from '../../store/EmployeeStore';

const { Text } = Typography;


const Certificates = observer(() => {
    const { loading: employeesLoading } = employeeStore;
    const { certificates, loading: certificatesLoading, fetchCertificates } = certificateStore;


    const navigate = useNavigate();
    useEffect(() => {
        employeeStore.fetchEmployees()
        certificateStore.fetchCertificates();
    }, []);
    const [searchText, setSearchText] = useState('');
    const [sortedInfo, setSortedInfo] = useState({});

    const [open, setOpen] = useState(false);
    const [editingCert, setEditingCert] = useState(null);

    const filtered = filterBySearch(certificates, searchText, (item) => {
        const employeeName = employeeStore.getEmployeeById(item.employeeId)?.name || '';
        return [
            item.name,
            employeeName,
            item.info,
        ];
    });


    const handleChange = (_, __, sorter) => {
        setSortedInfo(sorter);
    };

    const columns = [
    {
        title: 'Название',
        dataIndex: 'name',
        sorter: (a, b) => a.name.localeCompare(b.name),
        sortOrder: sortedInfo.columnKey === 'name' ? sortedInfo.order : null,
        key: 'name',
        render: (text) => (
            <Text
                style={{
                    display: 'block',
                    maxWidth: 500,       // максимальная ширина
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                }}
                title={text}             // показывает полный текст при hover
            >
                {highlightMatch(text, searchText, (t) => <Text mark>{t}</Text>)}
            </Text>
        ),
    },
    {
        title: 'Сотрудник',
        dataIndex: 'employeeId',
        key: 'employeeName',
        sorter: (a, b) => {
            const nameA = employeeStore.getEmployeeById(a.employeeId)?.name || '';
            const nameB = employeeStore.getEmployeeById(b.employeeId)?.name || '';
            return nameA.localeCompare(nameB);
        },
        sortOrder: sortedInfo.columnKey === 'employeeName' ? sortedInfo.order : null,
        render: (employeeId) => {
            const name = employeeStore.getEmployeeById(employeeId)?.name || '';
            return highlightMatch(name, searchText, (t) => <Text mark>{t}</Text>);
        },
    },
    {
        title: 'Срок действия',
        key: 'expired',
        sorter: (a, b) => {
            if (!a.hasDeadline && b.hasDeadline) return 1;
            if (a.hasDeadline && !b.hasDeadline) return -1;
            if (!a.hasDeadline && !b.hasDeadline) return 0;
            return new Date(a.expired) - new Date(b.expired);
        },
        sortOrder: sortedInfo.columnKey === 'expired' ? sortedInfo.order : null,
        render: (_, record) => getTagColor(record.expired, record.hasDeadline),
    },
];


    if (certificatesLoading && employeesLoading) return <Loader/>;

    return (
        <>
          <Flex style={{ marginBottom: 16 }} wrap gap="small">

                
                <>
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => {
                            setEditingCert(null);
                            setOpen(true);
                        }}
                        >
                        Добавить удостоверение
                        </Button>

                    {/* или setEditingCert(cert) для редактирования */}

                    <CertificateModalForm
                        open={open}
                        onClose={() => setOpen(false)}
                        certificate={editingCert}
                    />
                </>
                <ExcelUploadModal/>
                <Input.Search
                    placeholder="Поиск…"
                    allowClear
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    style={{ width: 300 }}
                />
            </Flex>
            <Table
                rowKey="id"
                columns={columns}
                dataSource={filtered}
                onChange={handleChange}
                pagination={false}
                onRow={(record) => ({
                    onClick: () => navigate(`/certificates/${record.id}`),
                })}
                scroll={{ x: 'max-content', y: 500 }} // y: 600px — высота скролла
            />

        </>
    );
})

export default Certificates;
